import { createAction } from 'redux-actions'
import {
  SHOW_EMAIL_VERIFICATION_FORM_REQUEST,
  SHOW_EMAIL_VERIFICATION_FORM_FAILED,
  SHOW_EMAIL_VERIFICATION_FORM_SUCCEEDED,
  SEND_NEW_EMAIL_VERIFICATION_REQUEST,
  SEND_NEW_EMAIL_VERIFICATION_FAILED,
  SEND_NEW_EMAIL_VERIFICATION_SUCCEEDED,
} from 'Redux/Types/EmailVerificationTypes'

export const showEmailVerificationForm = createAction(SHOW_EMAIL_VERIFICATION_FORM_REQUEST)
export const showEmailVerificationFormFailed = createAction(SHOW_EMAIL_VERIFICATION_FORM_FAILED)
export const showEmailVerificationFormSucceeded = createAction(
  SHOW_EMAIL_VERIFICATION_FORM_SUCCEEDED,
)

export const sendNewEmailVerification = createAction(SEND_NEW_EMAIL_VERIFICATION_REQUEST)
export const sendNewEmailVerificationFailed = createAction(SEND_NEW_EMAIL_VERIFICATION_FAILED)
export const sendNewEmailVerificationSucceeded = createAction(SEND_NEW_EMAIL_VERIFICATION_SUCCEEDED)
